import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, Events, ToastController,ViewController } from 'ionic-angular';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';

@Component({
  selector: 'page-forgot-password',
  templateUrl: 'forgot-password.html',
})
export class ForgotPasswordPage {
  passwordRecover:any;
  recoverPasswordCtrl: any;
  new_password: any = '';
  con_password: any = '';
  userEmailId:any='';
  resData: any;
  constructor(public navCtrl: NavController, private popup: AlertController, public viewCtrl: ViewController, public navParams: NavParams, private EncrDecrService: EncrDecrServiceProvider, public events: Events, public toastController: ToastController,public configApiService:ConfigApiServiceProvider) {
  }
  ngOnInit() {
    let urlParams = '';
    if (window.location.search.split('&').length > 1) {
      for (var i = 0; i < window.location.search.split('&').length; i++) {
        if (window.location.search.split('&')[i].split('=')[0] == 'RecoverPassword') {
          urlParams = window.location.search.split('&')[i].split('=')[1];
          break;
        }
      }
    } else {
      urlParams = window.location.search.split('=')[1];
    }

    urlParams = urlParams.replace(/%22/g, '"');
    urlParams = 'RecoverPassword=' + this.EncrDecrService.decrypt('DRIVESYNC123##', urlParams);

    for (var i = 0; i < urlParams.split('&').length; i++) {
      if (urlParams.split('&')[i].split("=")[0] == "RecoverMail") {
        this.userEmailId = urlParams.split('&')[i].split("=")[1]
      } 
    }
  }
  ionViewDidLoad() {
  }
  ngAfterViewInit() {
  
      this.forgotPassword();
  }
  forgotPassword(){
      this.recoverPasswordCtrl = this.popup.create({
        title: 'Recover Password',
        cssClass: 'resetPassword_Main',
        inputs: [
          {
            name: "recoverMailID",
            placeholder: 'Email ID',
            type:'email',
            value:this.userEmailId ,
          },
          {
            name: 'recoverNewPassword',
            placeholder: 'New Password',
            type: 'password',
            value:""
          },
          {
            name: 'recoverConfirmPassword',
            placeholder: 'Confirm Password',
            value:""
          }
        ],
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: data => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'Save',
            handler: data => {
              console.log('Save clicked');
              if(data.recoverMailID == ""){
                this.failedAlert("Email ID is required");
              }else if (data.recoverNewPassword == "") {
                this.failedAlert("New Password is required");
              } else if (data.recoverConfirmPassword == "") {
                this.failedAlert("Confirm Password is required");
              } else if(data.recoverNewPassword == data.recoverConfirmPassword){
                this.userEmailId = data.recoverMailID;
                this.new_password = data.recoverNewPassword;
                this.con_password = data.recoverConfirmPassword;
                this.proccessForgotPassword();
              }else{
                if(data.recoverMailID != ""){
                  this.userEmailId = data.recoverMailID;
                }
                const toast = this.toastController.create({
                  message: 'Please Enter valid password!',
                  duration: this.configApiService.toastDuration,
                });
                toast.present();
                this.forgotPassword();
              }
            }
          }
  
        ],
        enableBackdropDismiss: false

      });
  
      this.recoverPasswordCtrl.present();
  }
  failedAlert(text) {
    let alert = this.popup.create({
      cssClass: 'recoverPassword_Main',
      title: 'Failed',
      subTitle: text,
      buttons: [{
        text: 'OK',
        handler: () => {
          this.forgotPassword();
        }
      }]

    });
    alert.present();
  }

  proccessForgotPassword() {
    var new_password = this.EncrDecrService.set('BETSYENC123$$', this.new_password);
    var confirm_password = this.EncrDecrService.set('BETSYENC123$$', this.con_password);

    let data = {};
    data = {
      "client":"eprodcast",
      "rptname":"Forget_Password",
      "Email":this.userEmailId,
      "New_Password":new_password,
      "Confirm_Password":confirm_password,
      "userid":"8"
    }
    this.configApiService.pushRequest(data, this.forgotPasswordResponse);
    this.userEmailId = '';
    this.new_password = '';
    this.con_password = '';
  }

  forgotPasswordResponse = ((result) => {
    if(result == "SUCCESS"){
      this.recoverPasswordCtrl.dismiss();
      let successAlert: any = '';
      successAlert = this.popup.create({
        title: 'Reset Success',
        subTitle: 'Reset Password successfully. You will be logged out from your account. Please, Login again.',
        buttons: [{
          text: 'Ok',
          handler: () => {
            console.log('Confirm Ok');
          }
        }]
      });

      successAlert.present();
      let __this: any = this;
      successAlert.onDidDismiss(function () {
       var redirectPath = window.location.href.substring(0, window.location.href.lastIndexOf("&"));
       window.location.replace(redirectPath)
      })
    }else if (result.Result == "FAILED") {
      var pass_result = result.message;
      alert(pass_result);
      this.forgotPassword();
    }
  })
  public close() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-password/forgot-password.ts